import angular from "angular";
import requestLogs from "./request-logs/request-logs.component";
import mobiusErrors from "./mobius-errors/mobius-errors";
import mobiusHandlers from "./mobius-handlers/mobius-handlers";
import mobiusNotifications from "./mobius-notifications/mobius-notifications";

angular.module('mobiusControl.module', [
    requestLogs,
    mobiusErrors,
    mobiusHandlers,
    mobiusNotifications
]);

export default "mobiusControl.module"


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/mobius-control.module.js